import type { ThemeBreakpointsMin } from "./theme-breakpoints.type";

export const THEME_BREAKPOINTS_MIN: ThemeBreakpointsMin = {
  xs: 0, // xs = 0-575px
  sm: 576, // sm = 576-767px
  md: 768, // md = 768-991px
  lg: 992, // lg = 992-1199px
  xl: 1200, // xl = 1200-1599px
  xxl: 1600, // xxl = 1600-1919px
  xxxl: 1920, // xxxl = ≥1920
};
